import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'titleCaseKey',
})
export class TitleCaseKeyPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    return value
      .replace(/_/g, ' ') // replace underscores with space
      .replace(/[^a-zA-Z0-9 ]/g, ' ') // remove special characters except space
      .toLowerCase() // convert to lowercase
      .replace(/\b\w/g, (char) => char.toUpperCase()) // capitalize each word
      .trim(); // remove leading/trailing spaces
  }
}
